import { ethers } from 'ethers';
import { StakingAddresses } from '../../context/appContextInterfaces';

const stakingViewsLocatorAbi = [
  'function getStakingViewsFacet() view returns (address)',
];
const stakingViewsAbi = [
  'function getTokenContractAddress() view returns (address)',
];

export enum chainNames {
  YELLOWSTONE = 'yellowstone',
  LIT_CHAIN = 'litChain',
}

const litChains = {
  yellowstone: {
    name: chainNames.YELLOWSTONE,
    rpcUrl: 'https://yellowstone-rpc.litprotocol.com',
    explorer: 'https://yellowstone-explorer.litprotocol.com',
  },
  litChain: {
    name: chainNames.LIT_CHAIN,
    rpcUrl: 'https://lit-chain-rpc.litprotocol.com',
    explorer: 'https://lit-chain-explorer.litprotocol.com',
  },
};

export enum networkNames {
  CUSTOM = 'custom',
  NAGA_STAGING = 'naga_staging',
  NAGA_TEST = 'naga_test',
  NAGA_PROTO = 'naga_proto',
  NAGA_PROD = 'naga_prod',
}

export const networks = {
  custom: {
    network: networkNames.CUSTOM,
    stakingAddress: '',
    chain: litChains.yellowstone,
  },
  naga_staging: {
    network: networkNames.NAGA_STAGING,
    stakingAddress: '0x9b8Ed3FD964Bc38dDc32CF637439e230CD50e3Dd',
    chain: litChains.yellowstone,
  },
  naga_test: {
    network: networkNames.NAGA_TEST,
    stakingAddress: '0x9f3cE810695180C5f693a7cD2a0203A381fd57E1',
    chain: litChains.yellowstone,
  },
  naga_proto: {
    network: networkNames.NAGA_PROTO,
    stakingAddress: '0xCAB88Cf4c6132c7060Be95AA9254810d2D136E69',
    chain: litChains.litChain,
  },
  naga_prod: {
    network: networkNames.NAGA_PROD,
    stakingAddress: '0x8a861B3640c1ff058CCB109ba11CA3224d228159',
    chain: litChains.litChain,
  },
};

const getLitTokenContractAddress = async (
  stakingContractAddress: StakingAddresses
) => {
  console.log('Resolving network info from chain, 1 sec...');
  const provider = new ethers.providers.JsonRpcProvider(
    stakingContractAddress.chain.rpcUrl
  );

  // Resolve the views facet first, then fetch token address from it
  const stakingContract = new ethers.Contract(
    stakingContractAddress.stakingAddress,
    stakingViewsLocatorAbi,
    provider
  );
  const viewsFacetAddress: string = await stakingContract.getStakingViewsFacet();
  const viewsFacet = new ethers.Contract(
    viewsFacetAddress,
    stakingViewsAbi,
    provider
  );
  return await viewsFacet.getTokenContractAddress();
};

export default getLitTokenContractAddress;
